class ProfilePasswordController {}

angular.module('app.profile').component('profilePassword', {
  templateUrl: 'profile/components/password.html',
  controller: ProfilePasswordController,
});
